import { compose } from 'recompose';

import ContactsList from './ContactsList';

const enhance = compose();

export default enhance(ContactsList);
